var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "legal-search" },
    [
      _c(
        "div",
        { staticClass: "legal-search-send" },
        [
          _c(_setup.LfLabelButtonComponent, {
            staticClass: "button",
            attrs: {
              text: _setup.texts.legalBtn,
              title: _setup.texts.legalTooltip,
              action: _setup.openSearchOnApp,
              variant: _setup.LabelButtonVariant.OUTLINED,
            },
          }),
        ],
        1
      ),
      _c(
        "v-tabs",
        {
          staticClass: "tabs-other-styles legal-search-tabs",
          attrs: {
            "background-color": "transparent",
            "hide-slider": "",
            "show-arrows": "",
            "next-icon": _setup.icons.doubleArrowRight,
            "prev-icon": _setup.icons.doubleArrowLeft,
            ripple: false,
          },
          model: {
            value: _setup.selectedTabIndex,
            callback: function ($$v) {
              _setup.selectedTabIndex = $$v
            },
            expression: "selectedTabIndex",
          },
        },
        _vm._l(_setup.tabs, function (tab, tabIndex) {
          return _c(
            "v-tab",
            {
              key: `tab-${tab.area}`,
              class: [
                { "change-tab-styles": _vm.$vuetify.breakpoint.mdAndUp },
                "tab",
              ],
              attrs: { ripple: false, "active-class": "active" },
              on: {
                change: function ($event) {
                  return _setup.onTabChange(tab)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(tab.title))]),
              tab.total
                ? _c("span", [_vm._v("(" + _vm._s(tab.occurrences) + ")")])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _setup.selectedCurrentTabIndex,
            callback: function ($$v) {
              _setup.selectedCurrentTabIndex = $$v
            },
            expression: "selectedCurrentTabIndex",
          },
        },
        [
          _setup.showContent
            ? _c(
                "v-tab-item",
                {
                  staticClass: "tab-content",
                  attrs: { transition: false, "reverse-transition": false },
                },
                [
                  _c(
                    "div",
                    _vm._l(_setup.data, function (item, itemIndex) {
                      return _c(
                        "div",
                        { key: itemIndex, staticClass: "legal-item" },
                        [
                          _c("div", { staticClass: "legal-separator" }, [
                            _c("div", { staticClass: "legal-lead-in" }, [
                              item.leadIn
                                ? _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(item.leadIn),
                                    },
                                  })
                                : _vm._e(),
                            ]),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "legal-info-container" },
                                [
                                  item.title
                                    ? _c("div", {
                                        staticClass: "legal-title",
                                        domProps: {
                                          innerHTML: _vm._s(item.title),
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _setup.viewDocumentOnApp(
                                              item.nRef
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c(_setup.LfLabelButtonComponent, {
                                    staticClass: "button",
                                    attrs: {
                                      text: "Ver en BBDD jurídica",
                                      title:
                                        "Navegar en ventana nueva al documento original",
                                      action: () =>
                                        _setup.viewDocumentOnApp(item.nRef),
                                      variant: _setup.LabelButtonVariant.TEXT,
                                      prependIcon: _setup.icons.database,
                                    },
                                  }),
                                ],
                                1
                              ),
                              item.summary
                                ? _c("div", { staticClass: "legal-summary" }, [
                                    _c("img", {
                                      staticClass: "legal-icon",
                                      attrs: {
                                        src: require("@/assets/images/svg/quote.svg"),
                                        alt: "Quote icon",
                                      },
                                    }),
                                    _c("div", {
                                      staticClass: "legal-summary-text",
                                      domProps: {
                                        innerHTML: _vm._s(item.summary),
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "legal-footer" },
                    [
                      _setup.showContent && _setup.showPaginator
                        ? _c(_setup.PaginationComponent, {
                            staticClass: "pagination-component",
                            style: _setup.cssVars,
                            attrs: {
                              totalPages: _setup.totalPages,
                              maxVisibleButtons: _setup.maxVisibleButtonsPage,
                              currentPage: _setup.numPage + 1,
                            },
                            on: { pageChanged: _setup.onPageChanged },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "select-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "legal-select-num-recs" },
                          [
                            _setup.showPaginator
                              ? _c("v-select", {
                                  attrs: {
                                    items: _setup.numRecsPerPage,
                                    "append-icon": _setup.icons.arrowDown,
                                    "menu-props": {
                                      contentClass: "legal-paginator-list",
                                    },
                                  },
                                  on: { change: _setup.refreshSearch },
                                  model: {
                                    value: _setup.recsPerPage,
                                    callback: function ($$v) {
                                      _setup.recsPerPage = $$v
                                    },
                                    expression: "recsPerPage",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _setup.showPaginator
                          ? _c("div", { staticClass: "recs-per-page" }, [
                              _vm._v(
                                " " + _vm._s(_setup.texts.recsPerPage) + " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _setup.showPaginator
                        ? _c("div", { staticClass: "legal-page-info" }, [
                            _vm._v(" " + _vm._s(_setup.numPagesLiteral) + " "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "v-tab-item",
                [
                  _c(_setup.SpinnerLayerComponent, {
                    staticClass: "spinner-layer",
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }